// ======================================================================
// FILE: src/modules/wms/dashboard/components/ExecutivePerformanceTable.jsx
// MODULE: Work Management System (WMS)
// PURPOSE:
//   Executive Performance Table (Mock)
// ======================================================================

import React from "react";

export default function ExecutivePerformanceTable({
    data = [],
  }) {

  const rows = Array.isArray(data)
    ? data
    : [];

  return (

    <div className="card shadow-sm mb-4">

      <div className="card-header bg-white d-flex justify-content-between align-items-center">

        <h5 className="mb-0">
          Executive Performance
        </h5>

        <span className="badge bg-success">
          {rows.length} Executives
        </span>

      </div>

      <div className="table-responsive">

        <table className="table table-hover table-bordered align-middle mb-0">

          <thead className="table-light">

            <tr>

              <th>Executive</th>

              <th className="text-center">Assigned</th>

              <th className="text-center">Completed</th>

              <th className="text-center">Pending</th>

              <th className="text-center">Overdue</th>

              <th className="text-center">Today's Done</th>

              <th className="text-center">Escalated</th>

              <th className="text-center">Avg Time</th>

              <th className="text-center">SLA %</th>

              <th className="text-center">Score</th>

            </tr>

          </thead>

          <tbody>

            {rows.map((row, index) => (

              <tr
                key={index}
                style={{ cursor: "pointer" }}
              >

                <td>
                  <strong>{row.executive}</strong>
                </td>

                <td className="text-center">{row.assigned}</td>

                <td className="text-center text-success fw-bold">
                  {row.completed}
                </td>

                <td className="text-center">
                  {row.pending}
                </td>

                <td className="text-center text-danger fw-bold">
                  {row.overdue}
                </td>

                <td className="text-center">
                  {row.today}
                </td>

                <td className="text-center">

                  

                </td>

                <td className="text-center">
                  {row.avgTime ?? "—"}
                </td>

                <td className="text-center">

                  <span
                    className={`badge ${
                      row.sla === null || row.sla === undefined
                        ? "bg-secondary"
                        : "bg-primary"
                    }`}
                  >
                    {row.sla === null || row.sla === undefined
                      ? "—"
                      : `${row.sla}%`}
                  </span>

                  </td>

                                  <span
                    className={`badge ${
                      row.score === null || row.score === undefined
                        ? "bg-secondary"
                        : row.score >= 95
                          ? "bg-success"
                          : row.score >= 90
                            ? "bg-primary"
                            : "bg-warning text-dark"
                    }`}
                  >
                    {row.score === null || row.score === undefined
                      ? "—"
                      : row.score}
                  </span>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>

  );

}